import { useEffect, useRef } from "react";

import { useOption } from "#/store/options/tradePanel/option";

import { useWorker } from "../useWorker";

export function useTrackOptionInstrument() {
  const { worker, isWorkerReady } = useWorker();
  const { option } = useOption();

  const lastRef = useRef<string>(null);

  useEffect(() => {
    if (!isWorkerReady) return;

    if (!option) {
      worker!.setValues({ option: null });
      lastRef.current = null;
      return;
    }

    const changed = option.instrument_name !== lastRef.current;

    if (!changed) return;

    worker!.setValues({ option });
    lastRef.current = option.instrument_name;
  }, [option, worker, isWorkerReady]);
}
